
export function AboutSection() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-slate-800/50 to-slate-900/50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
              About <strong className="text-blue-400">Geosenture</strong>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              A Singapore-based global technology company driving innovation in energy and high-tech sectors
            </p>
          </div>

          {/* Mission & Vision */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-target-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Our Mission</h3>
              <p className="text-white/80 leading-relaxed text-lg">
                Through providing excellent technology consulting and solutions, we seamlessly connect global cutting-edge technological innovations with practical needs in the oil &amp; gas industry and high-tech sectors.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-eye-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">Our Vision</h3>
              <p className="text-white/80 leading-relaxed text-lg">
                To become a globally trusted technology partner and innovation catalyst for the oil &amp; gas industry, serving as the bridge connecting energy technology with a broader future.
              </p>
            </div>
          </div>

          {/* Company Background */}
          <div className="bg-gradient-to-r from-blue-900/20 to-slate-900/20 rounded-3xl p-12 backdrop-blur-sm border border-white/10">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-light text-white mb-6">
                  Global Technology <strong className="text-blue-400">Innovation</strong>
                </h3>
                <p className="text-white/80 leading-relaxed text-lg mb-6">
                  Geosenture is a global technology company, leveraging our unique position to integrate technological resources, industry expertise, and market opportunities across regions.
                </p>
                <p className="text-white/80 leading-relaxed text-lg mb-8">
                  Our core capability lies in the seamless integration of cutting-edge technologies with deep industry knowledge, creating solutions that drive both operational excellence and strategic innovation for our clients worldwide.
                </p>
                
                {/* Key Stats */}
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-400 mb-2">3</div>
                    <div className="text-white/70 text-sm">Global Regions</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-400 mb-2">2</div>
                    <div className="text-white/70 text-sm">Core Business Segments</div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/7d7cfb0446f316194ec52cc3a1646a11.jpg"
                  alt="Singapore Technology Hub"
                  className="w-full h-96 object-cover rounded-2xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
